import backIcon from "../assets/back_icon.svg";
import comLogo from "../assets/com-log.svg";
import dropDownIcon from "../assets/dropDownIcon.svg";
import lockHide from "../assets/lock_hide.svg";
import lockUnhide from "../assets/lock_unhide.svg";
import banner1 from "../assets/svg-icons/banner1.svg";
import building from "../assets/svg-icons/buildings.svg";
import button1 from "../assets/svg-icons/button.svg";
import candle from "../assets/svg-icons/candle.svg";
import card1 from "../assets/svg-icons/card1.svg";
import card2 from "../assets/svg-icons/card2.svg";
import card3 from "../assets/svg-icons/card3.svg";
import card4 from "../assets/svg-icons/card4.svg";
import card5 from "../assets/svg-icons/card5.svg";
import circleBanner from "../assets/svg-icons/circle-banner.svg";
import ArrowDown from "../assets/svg-icons/dropdown-up.svg";
import innovate from "../assets/svg-icons/innovate.svg";
import lightCircle from "../assets/svg-icons/light-circle.svg";
import lightLine from "../assets/svg-icons/light-line.svg";
import light from "../assets/svg-icons/light.svg";
import monitor from "../assets/svg-icons/monitor.svg";
import mouse from "../assets/svg-icons/mouse.svg";
import logo from "../assets/svg-icons/new-logo.svg";
import okta from "../assets/svg-icons/new-Okta-logo.svg";
import scaiBanner from "../assets/svg-icons/SCAI.svg";
import text1 from "../assets/svg-icons/text1.svg";
import touch from "../assets/svg-icons/touch.svg";
import microsoft from "../assets/svg-icons/Microsoft_logo.svg";
import microsoftLight from "../assets/svg-icons/micro.svg";
import oktaLight from "../assets/svg-icons/oktaa.svg";
import lock from "../assets/svg-icons/lock.svg";
import unlock from "../assets/svg-icons/unlock.svg";
import moon from "../assets/svg-icons/ligth-theme.svg";
import sun from "../assets/svg-icons/dark-theme.svg";
import arrowRight from "../assets/svg-icons/arrow-right.svg";
import shieldTick from "../assets/svg-icons/shield-tick.svg";
import copyrightImage from "../assets/svg-icons/© 2025 - All rights reserved.svg"
import LogoLight from "../assets/svg-icons/3scLogoLight.svg"
import languageLogo from "../assets/svg-icons/Language.svg"
import stars from "../assets/svg-icons/stars.svg"
import scai from "../assets/svg-icons/SCAI.svg";
import gotbg from "../assets/svg-icons/dot_BG.svg";
import Vector from "../assets/vector.svg";
import robo from "../assets/delivery.png";
import SCAI from "../assets/svg-icons/SCAI.svg";
import BackArrow from "../assets/svg-icons/BackArrow.svg";
import LockedpasswordIcon from "../assets/svg-icons/LockedpasswordIcon.svg";
import LockOpenPasswordIcon from "../assets/svg-icons/LockOpenPasswordIcon.svg";
import Animation from "../assets/video/Ai_bot.webp";
import Cross from "../assets/close-light.svg";
import Collapse from "../assets/expand-less.svg";
import Expand from "../assets/expand.svg";

const images = {
  Expand,
  Collapse,
  Cross,
  robo,
  scai,
  comLogo,
  backIcon,
  lockHide,
  lockUnhide,
  dropDownIcon,
  logo,
  mouse,
  banner1,
  okta,
  building,
  circleBanner,
  scaiBanner,
  light,
  lightLine,
  lightCircle,
  card1,
  card2,
  card3,
  card4,
  card5,
  touch,
  innovate,
  monitor,
  text1,
  button1,
  candle,
  ArrowDown,
  microsoft,
  microsoftLight,
  oktaLight,
  sun,
  moon,
  shieldTick,
  lock,
  unlock,
  copyrightImage,
  LogoLight,
  languageLogo,
  stars,
  gotbg,
  arrowRight,
  Vector,
  SCAI,
  BackArrow,
  LockedpasswordIcon,
  LockOpenPasswordIcon,
  Animation
};

export default images;
